import { createContext } from 'react';

const UiContext = createContext();

export default UiContext;
